import { GrowthBook } from '@growthbook/growthbook-react';

export const createDefaultGrowthBook = (): GrowthBook => {
  return new GrowthBook({
    attributes: {},
    features: {}, // empty features - hooks will return default values
  });
};
